// dataService.js
import { toast } from 'react-toastify';
import api from '../../../utils/ApiConfig';

// API pour Envoyer la demande (inchangé)
const addDemandeCommandeFournisseur = async (data, history) => {
  try {
    if (data instanceof FormData) {
      console.log("📦 Contenu FormData :");
      for (let [key, value] of data.entries()) {
        console.log(`${key}:`, value);
      }
    } else {
      console.log("Payload JSON :", JSON.stringify(data, null, 2));
    }

    const response = await api.post('/fo/sendMailDemandeCommandeFournisseur', data)
      .then((res) => {
        toast.success('Commande enregistré avec succès!', {
          position: 'top-right',
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          onClose: () => {
            history.push("/fournisseur/confirmation"); // Redirect to the confirmation page
          },
        });
      })
      .catch((err) => {
        console.log(err)
        toast.error('Échec. Veuillez réessayer.', {
          position: 'top-right',
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
      })
  } catch (error) {
    console.error('Error fetching');
    throw error;
  }
};

// vérification du token (inchangé)
const verifyToken = async (token) => {
  try {
    const response = await api.post('verificationToken', token);
    return response.data;
  } catch (error) {
    console.error('Error fetching');
    throw error;
  }
};

// 🔎 NOUVEAU: analyse du bordereau PDF pour extraire le poids
const parseBordereau = async (file) => {
  const fd = new FormData();
  fd.append('file', file);
  const { data } = await api.post('/bo/ocr-bordereau', fd);
  return data; // { ok: boolean, poids_total_kg?: number, bucket?: string }
};

// Export methods *****************************************************************************************
export { addDemandeCommandeFournisseur, verifyToken, parseBordereau }
